import BillingCmlMasterLocationsIndex from "@/components/billing_cml/master_locations/BillingCmlMasterLocationsIndex.vue";

let routesBillingCmlMasterLocations= [
    {
        path: '',
        meta: {
          title: "Billing CML Master Locations",
        },
        name: "BillingCmlMasterLocationsIndex",
        component: BillingCmlMasterLocationsIndex
    },
    
]

export default routesBillingCmlMasterLocations
  